// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bedrijf {\n  width: 100px;\n}\n", "",{"version":3,"sources":["webpack://./src/app/shared/components/inputrelatie/inputrelatie.component.less"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ","sourcesContent":[".bedrijf {\n    width:100px\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
